module.exports = __webpack_public_path__ + "img/changgou.02230f9a.png";